import React from 'react';
import { Col } from 'antd';
import { QLE_OPTIONS } from '../types';

interface QLESelectionProps {
  qle: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const QLESelection: React.FC<QLESelectionProps> = ({
  qle,
  onChange,
}) => {
  return (
    <Col sm={24} md={24} lg={24} xl={24}>
      <div className='radial-input'>
        <label>Qualifying life event *</label>
        <div className='radial-input-wrapper'>
          {QLE_OPTIONS.map((option) => (
            <label key={option}>
              <input
                type='radio'
                name='QLE'
                value={option}
                checked={qle === option}
                onChange={onChange}
              />
              {option}
            </label>
          ))}
        </div>
      </div>
    </Col>
  );
};
